<template>
  <lazy-theme7-base-not-found
    :is-full-screen-error="true"
    :background-color="vars.backgroundColor"
  >
    <template #title>
      <div class="tw-flex tw-flex-col tw-items-left tw-text-left tw-px-8">
        <!-- Sadece mobilde göster -->
        <h3
          class="d-block d-md-none  tw-mb-6"
        >
          <span>SORRY, THE PAGE YOU WERE LOOKING FOR WAS </span>
          <span class="tw-bg-yellow-300 tw-text-black tw-px-2 tw-rounded-lg">
            NOT FOUND
          </span>
        </h3>

        <!-- Tablet ve daha büyük ekranlarda göster -->
        <h1
          class="d-none d-md-block tw-mb-6 lg:tw-max-w-[100%]"
        >
          <span>SORRY, THE PAGE YOU WERE LOOKING FOR WAS </span>
          <span class="tw-bg-yellow-300 tw-text-black tw-px-4 tw-py-1 tw-rounded-lg">
            NOT FOUND
          </span>
        </h1>

        <!-- Açıklamalar -->
        <div v-if="descriptions" class="tw-mb-8">
          <p
            v-for="(item, idx) in descriptions"
            :key="`notfound-desc-${idx}`"
            class="tw-text-gray-600 tw-mb-2"
          >
            {{ item.description }}
          </p>
        </div>

        <!-- Buton -->
        <div>
          <nuxt-link
            :to="vars.buttonLinkUrl"
            class="n-primary n-btn tw-text-lg tw-px-6 tw-py-3"
          >
            {{ vars.buttonLabelText }}
          </nuxt-link>
        </div>
      </div>
    </template>
  </lazy-theme7-base-not-found>
</template>




<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'NotFoundPage',

  mixins: [ComponentMixin],

  setup() {
    const event = useRequestEvent();

    // event will be undefined in the browser
    if (event) {
      // Set the status message as well
      setResponseStatus(event, 404, 'Page Not Found');
    }
  },

  

  computed: {
    descriptions() {
      return this.groupedVariables.descriptions;
    },
    buttons() {
      return this.groupedVariables.buttons;
    },
  },
});
</script>

